export const MUT_GET_CATEGORIES = 'MUT_GET_CATEGORIES';
export const MUT_SET_CATEGORIES = 'MUT_SET_CATEGORIES';
export const MUT_ERR_CATEGORIES = 'MUT_ERR_CATEGORIES';
